import { render } from "./BrandMark.vue?vue&type=template&id=331a30ca&scoped=true"
import script from "./BrandMark.vue?vue&type=script&lang=js"
export * from "./BrandMark.vue?vue&type=script&lang=js"

import "./BrandMark.vue?vue&type=style&index=0&id=331a30ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331a30ca"]])

export default __exports__